import React from 'react';

import classNames from 'classnames';

import cls from './PrevImage.module.css';

interface IPrevImageProps {
    name: string;
    mimeType: string;
    previewSvgUrl: string;
}

export const PrevImage = ({ name, mimeType, previewSvgUrl }: IPrevImageProps) => {
    const isImage = !!mimeType?.indexOf('image');

    return (
        <div className={classNames(cls.imageWrapper, { [cls.notImage]: isImage })}>
            <img src={previewSvgUrl} alt={name} draggable="false" />
        </div>
    );
};
